import React from 'react'
import { Link } from 'react-router-dom'
import PageHeading from '../Global/PageHeading'
/* REDUX */
import { connect } from 'react-redux'
import { loadUserReports, deleteReport } from '../../actions/report'
import { formatDate } from '../../utility/Formatter'

class StackItem extends React.Component {
	
	handleDelete() {
		if(window.confirm("Are you sure you want to delete this report?")){
			const { report, deleteReport } = this.props
			deleteReport(report._id)
		} else {
			return false;
		}
	}
		
	render() {
		
		const { type, report } = this.props
		const { _id, title, blurb, created } = report
		
		let formattedDate = formatDate(created)
	
		return (
			<li>
				<div className="stack">
					<div className="row d-flex align-items-center">
						<div className="col-12 col-lg-7">
							<h4 className="title">{ title }</h4>
							<p className="blurb">{ blurb }</p>
						</div>
						<div className="col-12 col-lg-5">
							<div className="attributes">
								{type === 'Published' ? (
									<span className="attr attr-s"><span className="icon"><svg viewBox="0 0 512 512"><path d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg></span><span className="label">Published</span></span>
								) : (
									<span className="attr attr-d"><span className="icon"><svg viewBox="0 0 448 512"><path d="M433.941 193.941l-51.882-51.882A48 48 0 0 0 348.118 128H320V80c0-26.51-21.49-48-48-48h-61.414C201.582 13.098 182.294 0 160 0s-41.582 13.098-50.586 32H48C21.49 32 0 53.49 0 80v288c0 26.51 21.49 48 48 48h80v48c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V227.882a48 48 0 0 0-14.059-33.941zm-84.066-16.184l48.368 48.368a6 6 0 0 1 1.757 4.243V240h-64v-64h9.632a6 6 0 0 1 4.243 1.757zM160 38c9.941 0 18 8.059 18 18s-8.059 18-18 18-18-8.059-18-18 8.059-18 18-18zm-32 138v192H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h55.414c9.004 18.902 28.292 32 50.586 32s41.582-13.098 50.586-32H266a6 6 0 0 1 6 6v42h-96c-26.51 0-48 21.49-48 48zm266 288H182a6 6 0 0 1-6-6V182a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v170a6 6 0 0 1-6 6z"></path></svg></span><span className="label">Draft</span></span>
								)}
								<span className="attr attr-o"><span className="label">{ formattedDate }</span></span>
								<span className="attr attr-h" onClick={ this.handleDelete.bind(this) }><span className="icon m-0"><svg viewBox="0 0 448 512"><path d="M192 188v216c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12V188c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12zm100-12h-24c-6.627 0-12 5.373-12 12v216c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V188c0-6.627-5.373-12-12-12zm132-96c13.255 0 24 10.745 24 24v12c0 6.627-5.373 12-12 12h-20v336c0 26.51-21.49 48-48 48H80c-26.51 0-48-21.49-48-48V128H12c-6.627 0-12-5.373-12-12v-12c0-13.255 10.745-24 24-24h74.411l34.018-56.696A48 48 0 0 1 173.589 0h100.823a48 48 0 0 1 41.16 23.304L349.589 80H424zm-269.611 0h139.223L276.16 50.913A6 6 0 0 0 271.015 48h-94.028a6 6 0 0 0-5.145 2.913L154.389 80zM368 128H80v330a6 6 0 0 0 6 6h276a6 6 0 0 0 6-6V128z"></path></svg></span><span className="label"></span></span>
								<Link className="attr attr-h" to={'/editor/edit/' + _id}><span className="label">Edit</span></Link>
							</div>
						</div>
					</div>
				</div>
			</li>
		)
	}
}

class PublishedStack extends React.Component {
	render() {
		const { type, reports, deleteReport } = this.props
		
		const listReports = reports.map((report, index) => {
			if (type == 'Published' && report.published) {
				return <StackItem key={ index } type={ type } report={ report } deleteReport={ deleteReport } />
			}
		})
		
		return (
			<div className="manage">
				<h4 className="subheading">{ type }</h4>
				<div className="wrapper">
					<ul>
						{ listReports }
					</ul>
				</div>
			</div>
		)
	}
}

class DraftStack extends React.Component {
	render() {
		const { type, reports, deleteReport } = this.props
		
		const listReports = reports.map((report, index) => {
			if (type == 'Drafts' && !report.published) {
				return <StackItem key={ index } type={ type } report={ report } deleteReport={ deleteReport } />
			}
		})
		
		return (
			<div className="manage">
				<h4 className="subheading">{ type }</h4>
				<div className="wrapper">
					<ul>
						{ listReports }
					</ul>
				</div>
			</div>
		)
	}
}

const loadData = ({ loadUserReports }) => {
	loadUserReports()
}

class Content extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	render() {
		
		const { reports, deleteReport } = this.props
		
		return (
			<section className="content">
				<div className="container">
					<PageHeading heading={ "Your Reports" } />
					<PublishedStack type={ "Published" } reports={ reports } deleteReport={ deleteReport } />
					<DraftStack type={ "Drafts" } reports={ reports } deleteReport={ deleteReport } />
				</div>
			</section>
		)
	}
}

const mapStateToProps = (state) => {
	const { user } = state
	return {
		reports: user.reports
	}
}

export default connect(mapStateToProps, { loadUserReports, deleteReport })(Content)


// WEBPACK FOOTER //
// ./src/components/Manage/Content.js